module.exports = __webpack_public_path__ + "public/img/round1.8ec273d5.png";